import React, { Component } from 'react';
import { connect } from "react-redux";
import { HashRouter as Router } from 'react-router-dom'
import InstructorApp from './components/InstructorApp';

import couterpart from 'counterpart';
import en from './lang/en';
import vn from './lang/vn';
import $ from 'jquery';

couterpart.registerTranslations('en',en);
couterpart.registerTranslations('vn',vn);
couterpart.setLocale('vn');

class Application extends Component {
  componentDidMount () {
    $(function () {
        $(".popup img").click(function () {
            var $src = $(this).attr("src");
            $(".show").fadeIn();
            $(".img-show img").attr("src", $src);
        });
        
        $("span, .overlay").click(function () {
            $(".show").fadeOut();
        });
        
    });
  }

  render() {
    return (
      <Router >
        <InstructorApp />
      </Router>
    );
  }
}

export default connect()(Application);